/*
 * sola-instock-filter.js — "pick a size, see only what's in stock in that size".
 *
 * WHY: on this store each product is a single pre-owned pair, so SIZE is a product-level
 * metafield facet (filter.p.m.custom.shoe_size_* / apparel_size), and "that size is sold out"
 * simply means the product is sold out. Shopify's size facet returns every product tagged that
 * size — sold-out included — so shoppers filter to "size 10", click in, and it's gone.
 *
 * FIX: whenever a size facet is active, also engage the store's real "In stock" availability
 * facet (filter.v.availability=1). Doing it through the native facet — not by hiding cards —
 * keeps result counts and pagination correct AND leaves the visible "Availability" checkbox in
 * sync, so the UI never lies. Shoppers who actually want sold-out of a size can still untick it.
 *
 * TWO PATHS:
 *   1. In-app filtering (collection-filters.js does an AJAX section swap): a capture-phase
 *      change listener ticks the availability checkbox BEFORE the engine's bubble-phase handler
 *      serializes the form, so the request already carries availability=1 — instant, no reload.
 *   2. Direct navigation / reload / shared link: a first-paint guard adds availability=1 to the
 *      URL — via an IN-APP section swap (collection-filters.js's 'sola:swap' hook, history
 *      replace, no second page load; the old location.replace() double-load was the storefront's
 *      worst INP outlier). Falls back to location.replace only if the engine isn't present.
 *      It respects an EXPLICIT availability choice already in the URL and won't override it.
 *
 * Only reacts to SIZE facets — a manual toggle of the Availability facet is left untouched.
 */
(function () {
  var SIZE_RE = /^filter\..*size/i;                         // shoe_size_mw / _y / _c, apparel_size
  var AVAIL = 'filter.v.availability';

  // ---- Path 2: first paint / reload / shared link ----
  (function guard() {
    var p = new URLSearchParams(location.search);
    var sizeActive = false, availSet = false;
    p.forEach(function (v, k) {
      if (SIZE_RE.test(k)) sizeActive = true;
      if (k === AVAIL) availSet = true;                     // any explicit availability choice
    });
    if (sizeActive && !availSet) {
      p.append(AVAIL, '1');
      var target = location.pathname + '?' + p.toString();
      var doSwap = function () {
        var root = document.querySelector('[data-section-id]');
        var avail = root && root.querySelector('[data-facets-form] input[name="' + AVAIL + '"][value="1"]');
        if (root && avail) {
          avail.checked = true;              // keep the form state honest while the swap is in flight
          root.dispatchEvent(new CustomEvent('sola:swap', { detail: { url: target, mode: 'replace' } }));
        } else {
          location.replace(target);          // engine absent: keep the old (reload) behavior
        }
      };
      // Classic scripts run while the document is still parsing; wait for DOMContentLoaded so
      // collection-filters.js has attached its 'sola:swap' listener before we dispatch.
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', doSwap);
      else doSwap();
    }
  })();

  // ---- Path 1: in-app AJAX filtering ----
  var root = document.querySelector('[data-section-id]');
  if (!root) return;

  function anySizeChecked(form) {
    var boxes = form.querySelectorAll('input[type=checkbox][name]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].checked && SIZE_RE.test(boxes[i].name)) return true;
    }
    return false;
  }

  // Capture phase runs before collection-filters.js's bubble-phase change handler, so the
  // availability box is already in the right state when it serializes the form.
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name || !SIZE_RE.test(t.name)) return;      // only when a SIZE facet changes
    var form = t.closest('[data-facets-form]');
    if (!form) return;
    var avail = form.querySelector('input[name="' + AVAIL + '"][value="1"]');
    if (!avail) return;                                      // Availability facet not present
    avail.checked = anySizeChecked(form);                    // size on → in-stock on; last size off → release
  }, true);
})();
